<template lang="pug">
	.sfc-compare-checkbox(:class="{'checked' : isAPlanToCompare(plan)}" @click="$store.commit('updatePlansToCompare', plan)")
		span.checkmark
</template>
<style lang="stylus" scoped>
@import '~assets/css/redesign-v1/variables.styl'

.sfc-compare-checkbox
	width: 14px
	height: 14px
	border: 1px solid gray-50
	cursor: pointer
	position: relative
	border-radius(2px)
	background: #fff
	&.checked
		background: blue-primary
		border: 1px solid blue-primary
		.checkmark
			opacity 1
	.checkmark
		position relative
		top -12px
		left: 0px
		height: 5px
		width: 8px
		border-left: 2px solid #fff
		border-bottom: 2px solid #fff
		opacity: 0
		@media (max-width: 575px)
			top -14px

</style>
<script>
	import SfcTrackingService from "@/lib/sfc-tracking-service"
	import SfcUtil from "@/lib/sfc-util.js"
	export default {
		props: {
			plan: {
				type: Object,
				required: true
			}
		},
		methods: {
			isAPlanToCompare(plan){
				return SfcUtil.isAPlanToCompare(this.$store.state.plansToCompare, plan)
			}
		}
	}
</script>
